import styled, { css } from 'styled-components';
import Drawer from 'antd/es/drawer';
import Input from 'antd/es/input';

import Button from '@components/Button';
import { ItemText } from '@components/ui/search/SearchResultListStyle';

export const DrawerWrapper = styled.div`
  padding: 16px;
`;

export const ItemErrorText = styled(ItemText)`
  color: rgb(226, 35, 27);
  font-size: 14px;
`;

export const StyledDrawer = styled(Drawer)`
  &&& {
    .setur-drawer-body {
      padding-top: 0;
    }
    .setur-drawer-close {
      font-weight: bold;
      font-size: 23px;
      color: ${({ theme }) => theme.palette.black};
      padding: 15px;
    }

    .setur-drawer-title {
      width: fit-content;
      margin: 0 auto;
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      color: ${({ theme }) => theme.palette.darkGrey};
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    .setur-drawer-header {
      padding: 10px;
    }

    .location-animation-error {
      margin-top: 15px;
      border: 1px solid ${({ theme }) => theme.palette.primaryBrand};
      animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
      transform: translate3d(0, 0, 0);
      backface-visibility: hidden;
      perspective: 1000px;
    }

    @keyframes shake {
      10%,
      90% {
        transform: translate3d(-1px, 0, 0);
      }

      20%,
      80% {
        transform: translate3d(2px, 0, 0);
      }

      30%,
      50%,
      70% {
        transform: translate3d(-4px, 0, 0);
      }

      40%,
      60% {
        transform: translate3d(4px, 0, 0);
      }
    }
  }
`;

export const ResponsiveSearchDrawerItemContent = styled.div<{
  hasError: boolean;
}>`
  display: flex;
  padding: 8px 12px;
  align-items: center;
  gap: 12px;
  border-radius: 4px;
  background: ${({ theme }) => theme.palette.white};
  min-height: 56px;

  &.border-bottom-hidden {
    border-bottom: none;
  }

  ${({ hasError }) =>
    hasError &&
    css`
      border: 1px solid ${({ theme }) => theme.palette.errorColor};
      animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97);
    `}

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`;

export const ResponsiveSearchDrawerItemText = styled.div``;

export const ResponsiveSearchDrawerItemTitle = styled.span<{
  isFilled?: boolean;
}>`
  ${({ isFilled }) =>
    isFilled &&
    css`
      opacity: 0.5;
    `};
  font-size: 12px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const Wrapper = styled.div<{ isListingPage?: boolean }>`
  width: ${({ isListingPage }) => (isListingPage ? '330px' : '234px')};
  display: flex;
  flex-direction: row;
  position: relative;
  width: 150px;

  &:hover {
    background-color: white;
  }

  img {
    opacity: 0.8;
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;
export const ResponsiveSearchDrawerItemSubtitle = styled.span<{
  isFilled?: boolean;
}>`
  opacity: ${({ isFilled }) => (isFilled ? 1 : 0.5)};
  font-weight: ${({ isFilled }) => (isFilled ? 600 : 'normal')};
  font-size: 16px;
  color: ${({ theme, isFilled }) =>
    isFilled ? theme.palette.darkGrey : theme.palette.matterHorn};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    overflow: hidden;
    display: block;
    width: 230px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const ResponsiveSearchDrawerItemLabel = styled.span<{
  isFilled?: boolean;
}>`
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme, isFilled }) =>
    isFilled ? theme.palette.grey1100 : theme.palette.grey800};
  display: flex;
  flex: 1;
`;

// ==================================================
// ==================================================
// Style The Responsive Search By Location Start's Here
// ==================================================
// ==================================================

export const StyledListingLocationDrawer = styled(Drawer)`
  &&& {
    .setur-drawer-body {
      padding: 0 0;
    }

    .setur-drawer-header {
      display: flex;
      padding: 18px 16px;
      align-items: center;
      gap: 24px;
      min-height: 60px;
      background: ${({ theme }) => theme.palette.grey1100};

      .setur-drawer-close {
        margin-inline-end: 0px;
        padding: 0px;
      }
    }

    .setur-drawer-header-title {
      flex-direction: row-reverse;
    }

    .setur-drawer-title {
      color: ${({ theme }) => theme.palette.white};
      font-size: 14px;
      font-weight: 600;
      line-height: 24px;
    }

    .select-content {
      min-width: 100%;
    }

    .select-text-content {
      width: 100%;
    }
    .select-text {
      width: 100%;
    }

    .select-input {
      width: 100%;
    }
  }
`;

export const ResponsiveLocationDrawerContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ResponsiveListingSearchLocationSelect = styled.div`
  padding: 16px 16px 0px;
`;

export const ResponsiveListingSearchDateRangePicker = styled.div`
  grid-row: 1/2;
  height: 100%;
  margin: 0 15px 0 15px;
  border-bottom: 1px solid rgba(75, 75, 75, 0.5);

  &.select-box-icon {
    display: none;
  }

  & div {
    padding: 0;
  }
`;

export const ResponsiveLocationListItems = styled.div`
  width: 100%;
  height: 100%;
`;

export const ResponsiveLocationItems = styled.div`
  padding: 0px 24px 24px 24px;
  width: 100%;
  height: fit-content;
  height: 100%;
  overflow: auto;
  transition: all 0.5s;
  flex: 1;
`;

export const ListItemsWrappedByHeader = styled.div`
  padding: 20px 0px;
`;

export const ResponsiveLocationListItem = styled.div`
  display: flex;
  align-items: center;
  min-height: 48px;
  display: flex;
  align-items: center;
  width: 100%;
`;

export const ResponsiveLocationListItemContent = styled(Button).attrs({
  type: 'link',
})`
  &&& {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    flex: 1;
    position: relative;
    padding: 0px !important;
    height: auto !important;
    min-height: 48px;

    &:hover,
    &:focus {
      background: none;
      box-shadow: none;
    }
  }
`;

export const ResponsiveLocationListItemIcon = styled.div``;

export const ResponsiveLocationListItemText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.palette.grey1100} !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 16px !important;

  b {
    font-weight: 600 !important;
  }
`;

// ==================================================
// ==================================================
// Style The Responsive Search By Location End's Here
// ==================================================
// ==================================================

export const ResponsiveSearchDrawerButtonWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 15px;
  box-shadow: 0 10px 40px 0 rgba(58, 58, 58, 0.2);
  background-color: ${({ theme }) => theme.palette.white};
`;

// ==================================================
// ==================================================
// Style The Responsive Search By Date Start's Here
// ==================================================
// ==================================================

export const StyledListingDateDrawer = styled(Drawer)`
  &&& {
    .setur-drawer-body {
      padding: 0;
      position: relative;
    }

    .setur-drawer-title {
      width: fit-content;
      margin: 0 auto;
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      color: ${({ theme }) => theme.palette.darkGrey};
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    .setur-drawer-close {
      height: 100%;
      display: flex;
      align-items: center;
    }

    .setur-drawer-body > div {
      height: fit-content;
    }

    .select-box-icon {
      display: none;
    }

    .responsive-select-box {
      border-bottom: 1px solid rgba(75, 75, 75, 0.3);
      padding: 5px 0 10px 0;
    }
  }
`;

export const ResponsiveDatePickerSelect = styled.div`
  grid-row: 1/2;
  padding: 15px 0 0 15px;
`;

export const ResponsiveDatePickerWrapper = styled.div`
  position: relative;
  grid-row: 2/3;
  overflow: auto;
`;

// ==================================================
// ==================================================
// Style The Responsive Search By Guests Start's Here
// ==================================================
// ==================================================

export const StyledListingGuestDrawer = styled(Drawer)`
  &&& {
    .setur-drawer-body {
      padding: 0;
    }

    .setur-drawer-header {
      background: ${({ theme }) => theme.palette.grey1100};
      padding: 18px 16px;
    }

    .setur-drawer-header-title {
      gap: 24px;
      flex-direction: row-reverse;
    }

    .setur-drawer-title {
      color: ${({ theme }) => theme.palette.white};
      font-size: 14px;
      font-weight: 600;
      line-height: 24px;
    }

    .setur-drawer-close {
      height: 100%;
      display: flex;
      align-items: center;
      margin-inline-end: 0px;
      padding: 0px;
    }

    .responsive-room-header {
      display: flex;
      justify-content: space-between;
      padding-bottom: 12px;
      margin-bottom: 12px;
      border-bottom: 1px solid ${({ theme }) => theme.palette.grey300};
    }
  }
`;

export const ResponsiveGuestDrawerContent = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 70px;
  gap: 0px 0px;
`;

export const ResponsiveGuestRooms = styled.div`
  height: 100%;
  overflow: auto;
  padding: 12px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 60px;
  gap: 0px 0px;
`;

export const ResponsiveGuestRoomsList = styled.div`
  grid-row: 1/2;
`;

export const ResponsiveGuestRoomsNew = styled.div`
  grid-row: 2/3;
  padding: 0px 12px;
`;

export const ResponsiveGuestRoomsNewButton = styled(Button)``;

export const ResponsiveRoomLabel = styled.span`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
`;

export const ResponsiveRoomDeleteButton = styled.button`
  all: unset;
  height: 20px;
`;

export const ResponsiveRoomDeleteLabel = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: rgba(58, 58, 58, 0.75);
  margin-right: 4px;
`;

export const ResponsiveRoomMain = styled.div``;

export const ResponsiveSearchSubmitButtonWrapper = styled.div`
  grid-row: 3/4;
  width: 100%;
  padding: 12px;
  z-index: 9999999999;
  display: flex;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.palette.grey300};
  background: ${({ theme }) => theme.palette.white};
`;

export const ResponsiveSearchDrawerButton = styled(Button)`
  &&& {
    width: 100%;
    display: block;
    font-weight: bold;
  }
`;

export const StyledRoomsWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StyledListingGuestRoom = styled.div`
  width: 100%;
  height: auto;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.palette.grey300};
`;

export const ListingSearchInput = styled(Input)`
  &&& {
    display: flex;
    padding: 6px 12px;
    align-items: center;
    align-self: stretch;
    border-radius: 4px;
    border: ${({ theme }) => `1px solid ${theme.palette.grey200}`};
    background: ${({ theme }) => theme.palette.white};

    &.setur-input-affix-wrapper-focused {
      box-shadow: none;
    }

    .setur-input-prefix {
      margin-inline-end: 12px;
    }

    .setur-input {
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
      color: ${({ theme }) => theme.palette.grey1100};

      &::placeholder {
        color: ${({ theme }) => theme.palette.grey800};
      }
    }
  }
`;
export const SearchLabel = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: pre-wrap;
  text-align: left;

  b {
    font-weight: 600;
  }
`;

export const SearchSubLabel = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  opacity: 0.7;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: pre-wrap;
  text-align: left;
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const DrawerFooterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
`;
